module.exports = __webpack_public_path__ + "static/media/estatment.56806070.svg";